export function getActivityColor(action) {
  if (action?.includes("deleted") || action?.includes("removed")) {
    return "red";
  }
  if (action?.includes("created") || action?.includes("granted")) {
    return "green";
  }
  if (action?.includes("updated")) {
    return "amber";
  }
  return "purple";
}

export function formatActivityLabel(action) {
  return (action || "activity").replaceAll("_", " ");
}

export function formatActivityTimestamp(timestamp) {
  return timestamp ? new Date(timestamp).toLocaleString() : "Unknown time";
}

export function getActivityTargetName(item) {
  return (
    item?.target?.name ||
    item?.target?.email ||
    item?.target?.empId ||
    item?.target?.code ||
    item?.entityType ||
    "Unknown target"
  );
}

export function getActivityActorName(item) {
  return item?.actor?.empId || item?.actor?.email || "System";
}

export function buildActivitySummary(item) {
  const targetName = getActivityTargetName(item);
  const actorName = getActivityActorName(item);

  return {
    id: item?._id || `${item?.timestamp}-${item?.action}-${targetName}`,
    color: getActivityColor(item?.action),
    targetName,
    actorName,
    time: formatActivityTimestamp(item?.timestamp),
    actionLabel: formatActivityLabel(item?.action),
    text: `${formatActivityLabel(item?.action)}: ${targetName} by ${actorName}`,
    raw: item,
  };
}
export const activitiesCount = 4;
